import {
    EDIT_PATIENT, DELETE_PATIENT, CREATE_PATIENT, CREATE_PATIENT_SUCCESS, UPDATE_PATIENT_SUCCESS,
    UPDATE_PATIENT, DELETE_PATIENT_SUCCESS, FETCH_ALL_PATIENT, FETCH_ALL_PATIENT_SUCCESS,SET_PATIENT,SET_ROLE,
  } from 'constants/patients.constants'
import { startLoader } from 'actions/general.action';

export const setPatient = (key, value) => {
    return {
      type : SET_PATIENT,
      key: key,
      value: value
    }
}

export const setRoles = (key, value) => {
  return {
    type: SET_ROLE,
    key:key,
    value:value
  }
}

export const fetchPatients = (page) => {
    return dispatch => {
      dispatch({
        type: FETCH_ALL_PATIENT,
        payload: page
      })
      dispatch(startLoader())
    }
  }
  
  export const fetchPatientsSuccess = (data) => {
    return {
      type: FETCH_ALL_PATIENT_SUCCESS,
      payload: data
    };
  };

  export const deletePatient = (id) => {
    return {
      type: DELETE_PATIENT,
      payload: id
    };
  };
  
  export const editPatient = (id) => {
    return {
      type: EDIT_PATIENT,
      payload: id
    };
  };
  
  export const createPatient = (payload) => {
    console.log(payload)
    return {
      type: CREATE_PATIENT,
      payload: payload
    };
  };
  
  export const createPatientSuccess = (payload) => {
    return {
      type: CREATE_PATIENT_SUCCESS,
      payload: payload
    };
  };
  
  export const updatePatientSuccess = (data) => {
    return {
      type: UPDATE_PATIENT_SUCCESS,
      payload: data
    };
  };
  
  export const updatePatient = (payload) => {
    return {
      type: UPDATE_PATIENT,
      payload: payload
    };
  }; 

  export const deletePatientSuccess = (data) => {
    return {
      type: DELETE_PATIENT_SUCCESS,
      payload: data
    };
  };